module.exports = __webpack_public_path__ + "static/media/xk.4f3781ca.svg";